export default __webpack_public_path__ + "static/team1-91cae28044bcfa01669dfee9d1761c0a.png";